import { validate } from "com";
import { ORDERS_ENDPOINTS, STRIPE_ENDPOINTS } from "./endpoints";
import type { GetCheckoutSessionResponse, GetCheckoutSessionOptions } from "./types";
import { apiGet } from "../shared";
import { validateStripeSessionId } from "./validators";

export async function getCheckoutSession(
  sessionId: string,
  options: GetCheckoutSessionOptions = {}
): Promise<GetCheckoutSessionResponse> {
  validateStripeSessionId(sessionId);

  const queryParams = options.includeOrder ? "?includeOrder=true" : "";
  const url = `${STRIPE_ENDPOINTS.GET_SESSION(sessionId)}${queryParams}`;
  return apiGet<GetCheckoutSessionResponse>(url);
}

export async function getCheckoutSessionByOrder(orderId: string): Promise<GetCheckoutSessionResponse> {
  validate.uuid(orderId, "Order ID");
  return apiGet<GetCheckoutSessionResponse>(ORDERS_ENDPOINTS.GET_CHECKOUT_SESSION(orderId));
}
